'use client';

import { useMemo } from 'react';

import {
  buildWidgetPoweredByHref,
  resolveWidgetEmbedHostname,
  WIDGET_POWERED_BY_LINK_LABEL,
} from '@/lib/engage/widget-powered-by';
import { WIDGET_TEXT_BRANDING } from '@/lib/engage/widget-typography';

/**
 * TSAI `.branding` footer — do-follow link with UTMs for GA4 embed attribution.
 */
export function WidgetPoweredByBranding() {
  const href = useMemo(
    () => buildWidgetPoweredByHref(resolveWidgetEmbedHostname()),
    [],
  );

  return (
    <p
      className={`mt-2 text-center ${WIDGET_TEXT_BRANDING} text-zinc-500 dark:text-zinc-400`}
      data-s2r-component="widget-powered-by-branding"
    >
      Powered by{' '}
      <a
        className="underline underline-offset-2 hover:text-zinc-700 dark:hover:text-zinc-200"
        data-s2r-component="widget-powered-by-link"
        href={href}
        rel="noopener"
        target="_blank"
      >
        {WIDGET_POWERED_BY_LINK_LABEL}
      </a>
    </p>
  );
}
